import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import { useLocation, useNavigate } from 'react-router-dom';

import { MENU_ITEMS } from '@/shared/constants/menuItem';
import { MenuItemProps } from '@/shared/types/menuTypes';

const MenuItem: React.FC<MenuItemProps> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const isActive = item.relatedPaths.some((path) => currentPath.includes(path));
  const hasActiveSubmenu = item.submenu?.some((sub) =>
    currentPath.includes(sub.path),
  );
  const isSelected = isActive || hasActiveSubmenu;

  const handleClick = () => {
    if (item.hasSubmenu) {
      setIsOpen(!isOpen);
    } else {
      navigate(item.path);
    }
  };

  const handleSubmenuClick = (subItem: { name: string; path: string }) => {
    navigate(subItem.path);
  };

  return (
    <div>
      <div
        role="button"
        tabIndex={0}
        className={`flex cursor-pointer items-center justify-between px-6 py-3 transition-colors ${
          isSelected ? 'bg-[#8F689A] text-white' : 'text-[#8F689A]'
        }`}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick();
          }
        }}
      >
        <span>{item.name}</span>
        {item.hasSubmenu && (
          <span className={isSelected ? 'text-white' : 'text-[#8F689A]'}>
            {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </span>
        )}
      </div>
      {item.hasSubmenu && isOpen && (
        <div>
          {item.submenu!.map((subItem) => (
            <div
              key={subItem.path}
              role="button"
              tabIndex={0}
              onClick={() => handleSubmenuClick(subItem)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleSubmenuClick(subItem);
                }
              }}
              className={`cursor-pointer px-8 py-2 transition-colors ${
                currentPath.includes(subItem.path)
                  ? 'bg-[#8F689A] text-white'
                  : 'text-[#8F689A]'
              }`}
            >
              {subItem.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Nav = () => {
  return (
    <nav className="fixed left-0 top-14 h-screen w-60 overflow-y-auto bg-[#ebebeb]">
      <div className="min-h-full">
        {MENU_ITEMS.map((item) => (
          <MenuItem key={item.name} item={item} />
        ))}
      </div>
    </nav>
  );
};

export default Nav;
